import { styled } from "@mui/material/styles";
import { Box, Drawer } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { Button } from "./Button";

const MenuDrawer = styled(Drawer)(() => ({
  "& .MuiDrawer-paper": {
    width: "100%",
    height: "100%",
    background: "#ffffff",
    padding: "20px 16px",
    display: "flex",
    flexDirection: "column",
  },
}));

const MenuHeader = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: "40px",
}));

const LogoWrapper = styled(Box)(() => ({
  "& a": {
    lineHeight: 0,
    textDecoration: "none",
  },
  "& img": {
    width: "195px",
    height: "26px",
  },
}));

const CloseButton = styled("button")(() => ({
  background: "transparent",
  border: "none",
  fontSize: "24px",
  cursor: "pointer",
  padding: "8px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#000000",
}));

const MenuContent = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  gap: "24px",
}));

const MenuNavigation = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
}));

const MenuLink = styled(Link)<{ $active: boolean }>(({ $active }) => ({
  color: $active ? "var(--text-primary)" : "var(--text-tertiary)",
  fontFamily: "var(--font-family)",
  fontSize: "var(--paragraph-p2-font-size)",
  fontWeight: "var(--paragraph-p2-regular-font-weight)",
  lineHeight: "var(--paragraph-p2-line-height)",
  letterSpacing: "var(--paragraph-p2-letter-spacing)",
  textDecoration: "none",
  padding: "12px 0",
  transition: "color 0.2s",
  "&:hover": {
    color: "var(--text-primary)",
  },
}));

const MenuButtons = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "12px",
  marginTop: "auto",
  paddingBottom: "env(safe-area-inset-bottom)",
}));

interface MobileMenuProps {
  open: boolean;
  onClose: () => void;
}

export const MobileMenu = ({ open, onClose }: MobileMenuProps) => {
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  const logoMap: Record<string, string> = {
    "/wallet": "/assets/logo-wallet.svg",
    "/business": "/assets/logo-business.svg",
    "/invest": "/assets/logo-invest.svg",
  };
  const currentLogo = logoMap[location.pathname] || "/assets/logo.svg";

  const handleLinkClick = () => {
    onClose();
  };

  return (
    <MenuDrawer anchor="left" open={open} onClose={onClose}>
      <MenuHeader>
        <LogoWrapper>
          <Link to="/" onClick={handleLinkClick}>
            <img src={currentLogo} alt="Сфера" />
          </Link>
        </LogoWrapper>
        <CloseButton onClick={onClose} aria-label="Закрыть меню">
          ✕
        </CloseButton>
      </MenuHeader>

      <MenuContent>
        <MenuNavigation>
          <MenuLink
            to="/wallet"
            $active={isActive("/wallet")}
            onClick={handleLinkClick}
          >
            Сфера Кошелек
          </MenuLink>
          <MenuLink
            to="/business"
            $active={isActive("/business")}
            onClick={handleLinkClick}
          >
            Сфера Бизнес
          </MenuLink>
          <MenuLink
            to="/invest"
            $active={isActive("/invest")}
            onClick={handleLinkClick}
          >
            Сфера Инвест
          </MenuLink>
          <MenuLink
            to="/contacts"
            $active={isActive("/contacts")}
            onClick={handleLinkClick}
          >
            Контакты
          </MenuLink>
        </MenuNavigation>

        <MenuButtons>
          <Button variant="white" fullWidth>
            Войти
          </Button>
          <Button variant="primary" fullWidth>
            Демо
          </Button>
        </MenuButtons>
      </MenuContent>
    </MenuDrawer>
  );
};